<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="分组名称" prop="groupName">
        <el-input
          v-model="queryParams.groupName"
          placeholder="请输入分组名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="标签名称" prop="tagName">
        <el-input
          v-model="queryParams.tagName"
          placeholder="请输入标签名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['wxCp:ExternalUserTag:add']"
        >新增标签</el-button>
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAddTagGroup"
            v-hasPermi="['wxCp:ExternalUserTag:add']"
        >新增标签组</el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="mini"
          @click="RefreshCP_ExternalUserTagList"
          v-hasPermi="['wxCp:ExternalUserTag:add']"
        >同步企微客户标签</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="tagList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="标签id" align="center" prop="id" />
      <el-table-column label="分组id" align="center" prop="groupId" />
      <el-table-column label="分组名称" align="center" prop="groupName" />
      <el-table-column label="标签名称" align="center" prop="tagName" />
      <el-table-column label="创建时间" align="center" prop="tagCreateDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.tagCreateDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              v-hasPermi="['wxCp:ExternalUserTag:edit']"
          >修改</el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-hasPermi="['wxCp:ExternalUserTag:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改企业微信-客户标签对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标签名称" prop="tagName">
          <el-input v-model="form.tagName" placeholder="请输入标签名称" />
        </el-form-item>
        <el-form-item label="分组名称" prop="groupId">
          <el-select v-model="form.groupId" placeholder="请选择" disabled = true>
            <el-option
                v-for="item in tagGroupList"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改企业微信-客户标签组对话框 -->
    <el-dialog title="标签组" :visible.sync="openTagGroup" width="500px" append-to-body>
      <el-form ref="formTagGroup" :model="formTagGroup" :rules="rulesTagGroup" label-width="80px">
        <el-form-item label="分组名称" prop="groupName">
          <el-input v-model="formTagGroup.groupName" placeholder="请输入分组名称" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormTagGroup">确 定</el-button>
        <el-button @click="cancelTagGroup">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addExternalUserTag,
  delExternalUserTag,
  getExternalUserTag,
  listExternalUserTag,
  RefreshCP_ExternalUserTagList,
  updateExternalUserTag
} from "@/api/wxCp/ExternalUserTag";
import {listExternalUserTagGroup,addExternalUserTagGroup, updateExternalUserTagGroup} from "@/api/wxCp/ExternalUserTagGroup";

  export default {
  name: "ExternalUserTag",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 企业微信-客户标签表格数据
      tagList: [],
      // 企业微信-客户标签表格数据
      tagGroupList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      openTagGroup: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        groupId: null,
        groupName: null,
        tagName: null,
        updateDate: null,
        createDate: null
      },
      // 表单参数
      form: {},
      // 表单参数
      formTagGroup: {},
      // 表单校验
      rules: {
      },
      rulesTagGroup: {
      }
    };
  },
  created() {
    this.getList();
    this.getTagGroupList();
  },
  methods: {
    /** 查询企业微信-客户标签列表 */
    getList() {
      this.loading = true;
      listExternalUserTag(this.queryParams).then(response => {
        this.tagList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 查询企业微信-客户标签列表 */
    getTagGroupList() {
      listExternalUserTagGroup().then(response => {
        this.tagGroupList = response.rows;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 取消按钮
    cancelTagGroup() {
      this.openTagGroup = false;
      this.resetTagGroup();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        groupId: null,
        groupName: null,
        tagName: null,
        updateDate: null,
        createDate: null
      };
      this.resetForm("form");
    },
    // 表单重置
    resetTagGroup() {
      this.formTagGroup = {
        groupName: null,
      };
      this.resetForm("formTagGroup");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加企业微信-客户标签";
    },
    /** 新增按钮操作 */
    handleAddTagGroup() {
      this.resetTagGroup();
      this.openTagGroup = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getExternalUserTag(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改企业微信-客户标签";
      });
    },
    /** 提交按钮 */
    submitFormTagGroup() {
      this.$refs["formTagGroup"].validate(valid => {
        if (valid) {
          if (this.formTagGroup.id != null) {
            updateExternalUserTagGroup(this.formTagGroup).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.openTagGroup = false;
              this.getList();
            });
          } else {
            addExternalUserTagGroup(this.formTagGroup).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.openTagGroup = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateExternalUserTag(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addExternalUserTag(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除企业微信-客户标签编号为"' + ids + '"的数据项？').then(function() {
        return delExternalUserTag(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('wxCp/tag/export', {
        ...this.queryParams
      }, `tag_${new Date().getTime()}.xlsx`)
    },
    RefreshCP_ExternalUserTagList() {
      RefreshCP_ExternalUserTagList().then(response => {
        this.getList();
        this.$modal.msgSuccess("同步成功");
      });
    }
  }
};
</script>
